import { connect } from "react-redux";
import { sendTypingStart } from "../../../reduxV2/chats/chat.actions";
import ChatSendBar from "./ChatSendBar";
var mapStateToProps = function (state) { return ({}); };
var mapDispatchToProps = {
    sendTyping: sendTypingStart.getAction,
};
// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ChatSendBar);
